import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import BaseSection from '../Section'
import Header, { Title } from '../Header'
import Separator from '../Separator'
import Tooltip from 'components/Tooltip'
import useHandleCopyValue from 'utils/hooks/useHandleCopyValue'

const ContentContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.light.secondary};
  border: 1px dashed ${({ theme }) => theme.colors.border.dark.extraHigh};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.text.dark.primary};
  display: block;
  font-size: 0.8125rem;
  padding: 8px 12px;
  margin-right: 24px;
  cursor: pointer;
`

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${Header} {
    margin-right: 0;
  }
`

const Section = styled(BaseSection)`
  .CopyToClipboard {
    visibility: hidden;
  }
  &:hover .CopyToClipboard {
    visibility: visible;
  }
`

interface ContentProps {
  children: string
  style?: CSSProperties
}

const Content: React.FC<ContentProps> = ({ children, ...props }) => {
  const copyValue = children.split(/\r?\n/).join()

  const {
    handleCopyValue,
    copyTooltipText,
    handleEnterCopiableArea,
    handleLeaveCopiableArea,
    copyTooltipVisible,
  } = useHandleCopyValue(copyValue ?? '')

  const handleMouseEnterLabel = () =>
    !copyValue ? null : handleEnterCopiableArea()
  const handleMouseLeaveLabel = () =>
    !copyValue ? null : handleLeaveCopiableArea()

  return (
    <>
      <Separator />
      <Section data-testid="inspector-sidebar-content">
        <HeaderWrapper>
          <Header copyValue={children}>
            <Title>Content</Title>
          </Header>
        </HeaderWrapper>
        <ContentContainer
          data-testid="content-container"
          {...props}
          onClick={handleCopyValue}
          onMouseEnter={handleMouseEnterLabel}
          onMouseLeave={handleMouseLeaveLabel}>
          <Tooltip
            placement="left"
            spacing="10px"
            visible={copyTooltipVisible}
            content={copyTooltipText}>
            {children.split(/\r?\n/).map((text, index) => (
              <span key={index}>
                {text}
                <br />
              </span>
            ))}
          </Tooltip>
        </ContentContainer>
      </Section>
    </>
  )
}

export default Content
